import axios from 'axios';

import {
  axiosHeader,
  axiosHeaderV2,
  getV1RootUrl,
  getV2RootUrl,
  publicAxiosHeaderV2,
  publicAxiosHeader
} from 'common/helpers/apiHelper';
import { customerId as getCustomerId } from 'common/helpers/tokenHelper';

export const getCustomer = () =>
  axios.get(`${getV2RootUrl()}/customer/self`, axiosHeaderV2());

export const loginCustomer = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/login`,
    loginObject,
    publicAxiosHeader()
  );

export const logoutCustomer = () =>
  axios.post(`${getV1RootUrl()}/customer/logout`, {}, axiosHeader());

export const unsubscribeCustomer = (customerId, payload) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/unsubscribe`,
    payload,
    publicAxiosHeaderV2()
  );

export const googleLoginOrCreateCustomer = (loginObject) => {
  return axios.post(
    `${getV2RootUrl()}/customer/google-login-or-create`,
    loginObject,
    publicAxiosHeaderV2()
  );
};

export const fbLoginOrCreateCustomer = (loginObject) => {
  return axios.post(
    `${getV2RootUrl()}/customer/facebook-login-or-create`,
    loginObject,
    publicAxiosHeaderV2()
  );
};

export const validateMagicLinkId = (loginObject) =>
  axios.post(
    `${getV2RootUrl()}/customer/magic-link-login`,
    loginObject,
    publicAxiosHeaderV2()
  );

export const validateAccountActivationId = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/account-activation`,
    loginObject,
    publicAxiosHeader()
  );

export const validateResetPasswordId = (data) =>
  axios.post(
    `${getV2RootUrl()}/customer/reset-password-login`,
    data,
    publicAxiosHeaderV2()
  );

export const addCustomer = (customer) =>
  axios.post(
    `${getV2RootUrl()}/customer/for-web`,
    customer,
    publicAxiosHeaderV2()
  );

export const editCustomer = (customerId, params) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}`,
    params,
    axiosHeaderV2()
  );

export const editCustomerPassword = (customerId, params) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/password`,
    params,
    axiosHeader()
  );

export const forgotPassword = (data) =>
  axios.post(
    `${getV2RootUrl()}/customer/generate-reset-password-link`,
    data,
    publicAxiosHeaderV2()
  );

export const magicLink = (data) =>
  axios.post(
    `${getV2RootUrl()}/customer/generate-magic-link`,
    data,
    publicAxiosHeaderV2()
  );

export const resetPassword = (data) =>
  axios.post(
    `${getV2RootUrl()}/customer/reset-password`,
    data,
    publicAxiosHeaderV2()
  );

export const deleteCustomer = () =>
  axios.delete(`${getV1RootUrl()}/customer/${getCustomerId()}`, axiosHeader());
